module.exports = __webpack_public_path__ + "ai-bot-head-yeswpbbc4088d9b92b0059029d5ef2fdec2cd.png";